var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeddingLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "200px",
    width: "200px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 334.332 334.332",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4bd22"
    },
    d: "M167.167,15C104.714,15,53.905,65.811,53.905,128.266c0,25.648,20.354,67.061,58.857,119.758 c22.053,30.184,44.344,56.139,54.404,67.551c10.061-11.412,32.352-37.367,54.404-67.551 c38.504-52.697,58.855-94.109,58.855-119.758C280.427,65.811,229.62,15,167.167,15z M230.233,165.197 c-11.779,17.752-31.842,34.014-59.631,48.332c-1.078,0.557-2.258,0.834-3.436,0.834c-1.18,0-2.357-0.277-3.436-0.834 c-27.791-14.32-47.855-30.582-59.635-48.334c-13.094-19.73-12.805-36.396-10.258-46.9c4.902-20.219,22.826-34.893,42.619-34.893 c11.635,0,22.266,4.881,30.709,13.934c8.441-9.053,19.072-13.934,30.707-13.934c19.791,0,37.713,14.674,42.615,34.893 C243.038,128.801,243.325,145.465,230.233,165.197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#500da3"
    },
    d: "M197.874,83.402c-11.635,0-22.266,4.881-30.707,13.934c-8.443-9.053-19.074-13.934-30.709-13.934 c-19.793,0-37.717,14.674-42.619,34.893c-2.547,10.504-2.836,27.17,10.258,46.9c11.779,17.752,31.844,34.014,59.635,48.334 c1.078,0.557,2.256,0.834,3.436,0.834c1.178,0,2.357-0.277,3.436-0.834c27.789-14.318,47.852-30.58,59.631-48.332 c13.092-19.732,12.805-36.396,10.256-46.902C235.587,98.076,217.665,83.402,197.874,83.402z M108.417,121.83 c3.291-13.574,15.084-23.428,28.041-23.428c9.467,0,18.127,5.402,24.387,15.213c1.377,2.158,3.762,3.465,6.322,3.465 c2.561,0,4.945-1.307,6.322-3.465c6.26-9.811,14.918-15.213,24.385-15.213c12.955,0,24.746,9.854,28.039,23.428 c6.092,25.125-15.816,53.58-58.746,76.561C124.235,175.408,102.323,146.953,108.417,121.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#500da3"
    },
    d: "M167.167,0C96.444,0,38.905,57.539,38.905,128.266c0,68.816,117.721,198.158,122.731,203.631 c1.422,1.551,3.428,2.436,5.531,2.436c2.104,0,4.111-0.885,5.531-2.436c5.012-5.473,122.729-134.814,122.729-203.631 C295.427,57.539,237.89,0,167.167,0z M280.427,128.266c0,25.648-20.352,67.061-58.855,119.758 c-22.053,30.184-44.344,56.139-54.404,67.551c-10.061-11.412-32.352-37.367-54.404-67.551 c-38.504-52.697-58.857-94.109-58.857-119.758C53.905,65.811,104.714,15,167.167,15C229.62,15,280.427,65.811,280.427,128.266z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeddingLocation);
export default __webpack_public_path__ + "static/media/wedding_location.b07fd426bb60f9aa44af6c81b1f89f42.svg";
export { ForwardRef as ReactComponent };